import { endOfDay, isValid } from 'date-fns';

import { parseDateKey } from './format-date-key';

// parseDateKey keeps the day local — new Date(key) parses as UTC and drifts a day west.
export const isTodayBucketKey = (key: string, today: Date): boolean => {
  const date = parseDateKey(key);
  if (!isValid(date)) {
    return false;
  }
  return date.getTime() <= endOfDay(today).getTime();
};
